//=require ../utils.js

class FP_Checkout_Guest {
	constructor() {
		this.init();
	}

	init() {
		window.FirePluginsV2InvisibleReCaptcha = this.reCAPTCHACallback;

		document.addEventListener('input', (e) => {
			this.onValidateEmail(e);
			this.onValidatePassword(e);
		});

		document.addEventListener('keyup', (e) => {
			if (e.keyCode === 13) {
				this.submitForm(e.target);
			}
		});
		
		document.addEventListener('click', (e) => {
			this.onToggleForms(e);
			this.onFormSubmit(e);
		});


	}

	onValidateEmail(e) {
		const form = e.target.closest('.fp-checkout-credentials-form');
		if (!form) {
			return;
		}

		if (e.target.type !== 'email') {
			return;
		}

		let email = e.target;

		// Ensure email is not empty
		if (email.value === '') {
			email.classList.add('has-error');
			email.setCustomValidity('An email address is required.');
			email.reportValidity();
			return;
		}

		// Ensure valid email
		if (!this.validEmail(email.value)) {
			email.classList.add('has-error');
			email.setCustomValidity('A valid email address is required.');
			email.reportValidity();
			return;
		}

		email.classList.remove('has-error');
		email.setCustomValidity('');
		email.reportValidity();
	}

	onValidatePassword(e) {
		const form = e.target.closest('.fp-checkout-credentials-form');
		if (!form) {
			return;
		}

		if (e.target.type !== 'password') {
			return;
		}

		let password = e.target;

		// Ensure password is not empty
		if (password.value === '') {
			password.classList.add('has-error');
			password.setCustomValidity('A password is required.');
			password.reportValidity();
		}

		password.classList.remove('has-error');
		password.setCustomValidity('');
		password.reportValidity();
	}

	reCAPTCHACallback() {
		if (!window.grecaptcha) {
			return;
		}

		let items = document.querySelectorAll('.checkout-form-recaptcha');
		if (!items) {
			return;
		}

		items.forEach(item => {
			const form = item.closest('.fp-checkout-credentials-form');
			const options = {
				badge: item.dataset.badge,
				callback: function() {
					form.querySelector('button').click();
				},
				sitekey: item.dataset.sitekey,
				size: 'invisible'
			};

			const widgetID = grecaptcha.render(item, options);
			item.setAttribute('data-recaptcha-widget-id', widgetID);

			// Invoke the reCAPTCHA check when the user submits the form
			form.addEventListener('beforeSubmit', function(e) {
				if (e.defaultPrevented) {
					return;
				}

				const response = grecaptcha.getResponse(widgetID);

				// Do not proceed if the widget is already verified, 
				if (response.length > 0) {
					return;
				}

				e.preventDefault();

				grecaptcha.execute(widgetID);
			});

			// Reset the widget after the form is submitted
			form.addEventListener('afterSubmit', function(e) {
				grecaptcha.reset(widgetID);
			});
		});
	}

	onToggleForms(e) {
		let btn = e.target.closest('.tf-toggle-log-reg-forms');
		if (!btn) {
			return;
		}

		e.preventDefault();

		const wrapper = btn.closest('.fp-checkout-tabs--item[data-tab="step-2"]');

		if (wrapper.classList.contains('visible-create')) {
			wrapper.classList.remove('visible-create');
			wrapper.classList.add('visible-login');

			let loginForm = wrapper.querySelector('.fp-checkout-credentials-form[data-form-type="login"]');
			loginForm.querySelector('input[type="email"]').focus();
		} else {
			wrapper.classList.remove('visible-login');
			wrapper.classList.add('visible-create');

			let createForm = wrapper.querySelector('.fp-checkout-credentials-form[data-form-type="register"]');
			createForm.querySelector('input[type="email"]').focus();
		}
	}

	// Validate Email Address
	validEmail (email) {
		return String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);
	};

	onFormSubmit(e) {
		let btn = e.target.closest('.form-submit-btn');
		if (!btn) {
			return;
		}

		e.preventDefault();

		this.submitForm(btn);
	}

	submitForm(btn) {
		let form = btn.closest('.fp-checkout-credentials-form');
		if (!form) {
			return;
		}

		let formType = form.dataset.formType;
		
		let email = form.querySelector('input[name="' + formType + '_email"]');
		let password = form.querySelector('input[name="' + formType + '_password"]');

		// Reset fields
		email.classList.remove('has-error');
		password.classList.remove('has-error');

		let hasError = false;
		let isValidEmail = false;

		// Ensure email is not empty
		if (email.value === '') {
			email.classList.add('has-error');
			email.setCustomValidity('An email address is required.');
			email.reportValidity();
			hasError = true;
		}

		// Ensure valid email
		if (!this.validEmail(email.value)) {
			email.classList.add('has-error');
			email.setCustomValidity('A valid email address is required.');
			email.reportValidity();
			hasError = true;
		} else {
			isValidEmail = true;
		}

		// Ensure password is not empty
		if (password.value === '') {
			password.classList.add('has-error');
			password.setCustomValidity('A password is required.');
			hasError = true;
			
			if (isValidEmail) {
				password.reportValidity();
			}
		}

		if (hasError) {
			return;
		}

		if (form.classList.contains('is-working')) {
			return;
		}

		// Submit form
		let event = form.dispatchEvent(new CustomEvent('beforeSubmit', { cancelable: true }));
		if (!event) {
			return;
		}

		const self = this;

		form.classList.add('is-working');

		let button = form.querySelector('button.button');
		button.setAttribute('disabled', true);

		const discount = document.querySelector('.edd_discount_remove')?.dataset?.code || '';
		
		const data = new FormData();
		data.append('recaptcha_response', form.querySelector('textarea[name="g-recaptcha-response"]').value);
		data.append('download', document.querySelector('#edd_checkout_cart').dataset.download);
		data.append('price_id', document.querySelector('#edd_checkout_cart').dataset.downloadPriceId);
		data.append('tax_rate', document.querySelector('.checkout-cart-tax-rate').dataset.taxRate);
		data.append('discount', discount);
		data.append('email', email.value);
		data.append('password', password.value);
		data.append('nonce', form.querySelector('input[type="hidden"][name="fp_checkout_' + formType + '_nonce"]').value);
		data.append('action', 'fp_checkout_' + formType);

		fetch(fireplugins.ajax_url, {
			method: 'POST',
			body: data
		})
		.then(function(response) {
			return response.json();
		})
		.then((resp) => {
			form.classList.remove('is-working');

			if (!resp.success) {
				// Show error
				self.showNotice(resp.data.message, form);
			} else {
				self.showNotice(resp.data.message, form, 'success');

				form.remove();

				// Refresh page
				window.location.reload();
			}
			
			form.dispatchEvent(new CustomEvent('afterSubmit', { cancelable: true }));

			button.removeAttribute('disabled');
		});
	}
	
	showNotice(msg, form, type = 'error') {
		const alert = form.closest('.fp-checkout-tabs--item--content').querySelector('.checkout-alert');
		
		alert.innerHTML = msg;
		alert.classList.remove('alert-error', 'alert-success', 'alert-info', 'hide');
		alert.classList.add('alert-' + type);
	}

	hideNotice(form) {
		form.closest('.fp-checkout-tabs--item--content').querySelector('.checkout-alert').classList.add('hide');
	}
}

FP_Utils.onReady(function() {
	new FP_Checkout_Guest();
});